module.exports = __webpack_public_path__ + "static/travel-cbbf97facb70bad133a9f9a529d16cf4.mp4";